import React, { useState, useEffect, useRef } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import * as recipientActions from 'store/modules/recipientRegister/actions'
import { get } from 'lodash'
import ReactHtmlParser from 'react-html-parser'
import { Container, Form, Row, Col, Button, Spinner } from 'react-bootstrap'
import { registerLocale, setDefaultLocale } from 'react-datepicker'
import MaskedInput from 'react-maskedinput'
import ptBR from 'date-fns/locale/pt-BR'
import { cepMask, numberMask, cpfMask } from 'helpers/strings'
import { cpf } from 'cpf-cnpj-validator'

import Typography from 'components/atoms/Typography'
import CustomButton from 'components/atoms/CustomButton'
import Input from 'components/atoms/Input'
import CustomModal from 'components/molecules/CustomModal'

import 'react-datepicker/dist/react-datepicker.css'
import 'styles/datepicker.scss'
import './AtualizacaoCadastral.scss'

setDefaultLocale('pt-BR')
registerLocale('pt-BR', ptBR)

function AtualizacaoCadastral(props) {
  const { data, user } = props
  const myRef = useRef(null)
  const title = get(data, 'title')
  const description = get(data, 'description.value')
  const userId = get(user, 'profile_id')

  const dispatch = useDispatch()
  const { recipient, loadingRecipent, errorRecipent } = useSelector(
    ({ recipientRegisterData }) => recipientRegisterData
  )
  const { updateRecipient, loadingUpdatedRecipient, errorUpdateRecipient } = useSelector(
    ({ recipientRegisterData }) => recipientRegisterData
  )
  const { loadingSearchZipCode, errorSearchZipCode, searchZipCode } = useSelector(
    ({ recipientRegisterData }) => recipientRegisterData
  )

  const [modalZipCodeOpened, setModalZipCodeOpened] = useState(false)
  const [zipCodeList, setZipCodeList] = useState([])
  const [message, setMessage] = useState('')
  const [modalOpened, setModalOpened] = useState(false)
  const [formValidated, setFormValidated] = useState(false)
  const [cardRecipientData, setCardRecipientData] = useState({
    name: '',
    handleRecipient: '',
    handleCard: '',
    handleRegistration: '',
    code: '',
    type: '',
    dependentType: '',
    blocked: '',
    nameMother: '',
    cpf: '',
    email: '',
    address: {
      zipcode: '',
      handleResidential: '',
      handleMail: '',
      street: '',
      neighborhood: '',
      city: '',
      state: '',
      number: '',
      complement: '',
      handleState: '',
      handleCity: '',
      phoneDDD: '',
      phone: '',
      phonePrefix: '',
      phoneNumber: '',
      cellPhone: '',
      cellPhoneDDD: '',
      cellPhonePrefix: '',
      cellPhoneNumber: '',
    },
  })
  const cellPhoneNumber = cardRecipientData?.address?.cellPhonePrefix + cardRecipientData?.address?.cellPhoneNumber
  const phoneNumber = cardRecipientData?.address?.phonePrefix + cardRecipientData?.address?.phoneNumber

  const handleSubmit = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const form = e.currentTarget
    if (validateFields(form)) {
      saveCard()
    }
    setFormValidated(true)
  }

  const validateFields = (form) => {
    return (
      form.checkValidity() &&
      !errorRecipent &&
      !isInvalidPhoneNumber() &&
      !isInvalidPhoneDDD() &&
      !isInvalidCellPhoneNumber() &&
      !isInvalidCellPhoneDDD() &&
      cardRecipientData?.address?.street &&
      cardRecipientData?.address?.number &&
      cardRecipientData?.address?.city &&
      cardRecipientData?.address?.state &&
      cardRecipientData?.address?.neighborhood &&
      cepMask(cardRecipientData?.address?.zipcode)?.length == 9 &&
      !isInvalidNameMother()
    )
  }

  const saveCard = () => {
    const cardData = {
      input: {
        ...cardRecipientData,
        blocked: true,
        code: numberMask(cardRecipientData.code),
        cpf: numberMask(recipient.cpf),
      },
      handle: parseInt(userId),
    }
    dispatch(recipientActions.updateRecipientRegister(cardData))
  }

  const handleEdit = ({ target }) => {
    const { value } = target
    const name = target.getAttribute('name')

    setCardRecipientData((currentData) => {
      if (name.search('address') > -1) {
        const addressField = name.split('.')[1]
        currentData['address'][addressField] = value
      } else {
        currentData[name] = value
      }
      return { ...currentData }
    })
  }

  const handleEditPhone = ({ target: { value } }) => {
    const [phonePrefix, phoneNumber] = value.split('-')
    setCardRecipientData((currentData) => {
      currentData.address = {
        ...currentData.address,
        phonePrefix: numberMask(phonePrefix),
        phoneNumber: numberMask(phoneNumber),
      }
      return { ...currentData }
    })
  }

  const handleEditCellPhone = ({ target: { value } }) => {
    const [cellPhonePrefix, cellPhoneNumber] = value.split('-')
    setCardRecipientData((currentData) => {
      currentData.address = {
        ...currentData.address,
        cellPhonePrefix: numberMask(cellPhonePrefix),
        cellPhoneNumber: numberMask(cellPhoneNumber),
      }
      return { ...currentData }
    })
  }

  const searchCep = () => {
    if (!loadingSearchZipCode) {
      dispatch(recipientActions.searchZipCodeRegister({ zipcode: cardRecipientData?.address?.zipcode }))
    }
  }

  const setSelectedZipCode = (index) => {
    setCardRecipientData({
      ...cardRecipientData,
      address: {
        ...cardRecipientData.address,
        city: zipCodeList[index].locale,
        state: zipCodeList[index].state,
        street: zipCodeList[index].street,
        neighborhood: zipCodeList[index].neighborhood,
        number: '',
        complement: '',
      },
    })
    setModalZipCodeOpened(false)
  }

  useEffect(() => {
    if (!loadingUpdatedRecipient && (errorUpdateRecipient || errorRecipent)) {
      setMessage(
        errorUpdateRecipient
          ? 'Ocorreu um erro, favor entrar em contato com o atendimento Unimed.'
          : 'Ocorreu um erro ao localizar seu cadastro, favor entrar em contato com o atendimento Unimed.'
      )
      setModalOpened(true)
      if (myRef.current !== null) {
        myRef.current.scrollIntoView()
      }
    }
  }, [updateRecipient, errorUpdateRecipient, loadingUpdatedRecipient, errorRecipent])

  useEffect(() => {
    if (updateRecipient) {
      setMessage('Cadastro atualizado com sucesso!')
      if (myRef.current !== null) {
        myRef.current.scrollIntoView()
      }
      setModalOpened(true)
    }
  }, [updateRecipient])

  useEffect(() => {
    if (errorSearchZipCode) {
      setMessage('O CEP informado não foi encontrado. Verifique os dados e tente novamente')
      setModalOpened(true)
    } else {
      if (searchZipCode) {
        setZipCodeList([])
        setModalZipCodeOpened(false)
        const addresses = searchZipCode.zipcodeList.addresses
        if (addresses?.length == 1) {
          setCardRecipientData({
            ...cardRecipientData,
            address: {
              ...cardRecipientData.address,
              city: addresses[0].locale,
              state: addresses[0].state,
              street: addresses[0].street,
              neighborhood: addresses[0].neighborhood,
              number: '',
              complement: '',
            },
          })
        } else {
          const tempZipCodeList = []
          const aux = []

          addresses.forEach((item) => {
            const addObj = {
              street: item.street ? item.street.trim() : '',
              neighborhood: item.neighborhood ? item.neighborhood.trim() : '',
              locale: item.locale ? item.locale.trim() : '',
              state: item.state ? item.state.trim() : '',
            }
            const strAux = addObj.street + addObj.neighborhood + addObj.locale + addObj.state
            if (aux.indexOf(strAux) < 0) {
              tempZipCodeList.push(addObj)
              aux.push(strAux)
            }
          })

          setZipCodeList(tempZipCodeList)
          setModalZipCodeOpened(true)
        }
      }
    }
  }, [searchZipCode, errorSearchZipCode])

  useEffect(() => {
    const userHandle = { handle: parseInt(userId) }
    dispatch(recipientActions.getRecipientRegister(userHandle))
    setModalOpened(false)
    setModalZipCodeOpened(false)
  }, [])

  useEffect(() => {
    if (recipient) {
      setCardRecipientData(recipient)
    }
  }, [recipient])

  const isInvalidPhoneNumber = () => {
    return (
      (numberMask(phoneNumber)?.length > 0 || cardRecipientData?.address?.phoneDDD?.length) &&
      (numberMask(phoneNumber)?.length !== 8 || numberMask(phoneNumber)[0] < 1 || numberMask(phoneNumber)[0] > 6)
    )
  }

  const isInvalidPhoneDDD = () => {
    return (
      (cardRecipientData?.address?.phoneDDD?.length > 0 || phoneNumber?.length > 0) &&
      (cardRecipientData?.address?.phoneDDD < 11 || cardRecipientData?.address?.phoneDDD > 99)
    )
  }

  const isInvalidCellPhoneNumber = () => {
    return (
      (numberMask(cellPhoneNumber)?.length > 0 || cardRecipientData?.address?.cellPhoneDDD?.length) &&
      (numberMask(cellPhoneNumber)?.length !== 9 || numberMask(cellPhoneNumber)[0] < 7)
    )
  }

  const isInvalidCellPhoneDDD = () => {
    return (
      (cardRecipientData?.address?.cellPhoneDDD?.length > 0 || cellPhoneNumber?.length > 0) &&
      (cardRecipientData?.address?.cellPhoneDDD < 11 || cardRecipientData?.address?.cellPhoneDDD > 99)
    )
  }

  const isInvalidNameMother = () => {
    const nameMother = (cardRecipientData?.nameMother) ? cardRecipientData?.nameMother.toString().trim() : ''
    return !(nameMother && nameMother.split(' ')?.length > 1) || !(nameMother && nameMother.trim().length >= 8)
  }

  const validRegex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  return (
    <div className="update-profile">
      <Container className="mt-5" ref={myRef}>
        <Row>
          <Col>
            <Typography variant="h2" color="primary" cssClass="title-semibold-md mb-3">
              {title}
            </Typography>
            {description && (
              <Typography component="" color="gray-100" cssClass="bloco-conteudo-text mb-4">
                {ReactHtmlParser(description)}
              </Typography>
            )}
          </Col>
        </Row>
      </Container>

      {loadingRecipent ? (
        <Row className="justify-content-md-center my-5">
          <Col md="auto" className="text-center">
            <Spinner animation="border" />
          </Col>
        </Row>
      ) : (
        <Container className="mb-5 update-profile-form">
          <Form noValidate validated={formValidated} onSubmit={handleSubmit}>
            <Row>
              <Col md="8">
                <Row className="mb-3">
                  <Col>
                    <Form.Label>Nome do Beneficiário:</Form.Label>
                    <Form.Control
                      disabled={true}
                      type="text"
                      value={cardRecipientData?.name || ''}
                      onChange={handleEdit}
                      maxLength="150"
                    />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Label>Número do Cartão:</Form.Label>
                    <Form.Control
                      disabled={true}
                      type="text"
                      value={cardRecipientData?.code || ''}
                      onChange={handleEdit}
                      maxLength="20"
                    />
                  </Col>

                  <Col>
                    <Input
                      as={MaskedInput}
                      disabled={cpf.isValid(cpfMask(cardRecipientData?.cpf))}
                      errorMessage="Por favor informe um CPF válido"
                      label="CPF:"
                      onChange={handleEdit}
                      required
                      name="cpf"
                      value={cardRecipientData?.cpf}
                      validationType="cpf"
                      mask="111.111.111-11"
                    />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Input
                      disabled={!!errorRecipent}
                      label="Nome da mãe*:"
                      errorMessage="Por favor informe o nome completo da mãe"
                      value={cardRecipientData?.nameMother?.toUpperCase() || ''}
                      onChange={(event) => {
                        event.target.value = event.target.value.replace(/[0-9]+/, '')
                        handleEdit(event)
                      }}
                      name="nameMother"
                      maxLength="150"
                      isInvalid={isInvalidNameMother()}
                      type="text"
                    />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Input
                      label="E-mail:"
                      name="email"
                      maxLength="150"
                      value={cardRecipientData?.email || ''}
                      type="text"
                      disabled={true}
                    />
                  </Col>
                </Row>

                <Row className="input-cep">
                  <Col className="d-flex align-items-center">
                    <Input
                      as={MaskedInput}
                      className="zipcode"
                      mask="11111-111"
                      label="CEP*:"
                      type="text"
                      name="address.zipcode"
                      isInvalid={cepMask(cardRecipientData?.address?.zipcode)?.length < 9}
                      value={cardRecipientData?.address?.zipcode || ''}
                      onChange={handleEdit}
                      errorMessage="CEP inválido"
                      maxLength="9"
                      required
                    />
                    <Button
                      className="icone-acoes-lock"
                      onClick={searchCep}
                      disabled={!!errorRecipent ? true : false}
                      title="Atualizar endereço"
                    >
                      {loadingSearchZipCode && <Spinner animation="border" size="sm" />}
                      {!loadingSearchZipCode && <i className="icone-search"></i>}
                    </Button>
                    <Form.Control.Feedback type="invalid">Favor informar o CEP.</Form.Control.Feedback>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col>
                    <Input
                      label="Endereço*:"
                      type="text"
                      value={cardRecipientData?.address?.street?.toUpperCase() || ''}
                      name="address.street"
                      onChange={handleEdit}
                      maxLength="150"
                      errorMessage="Favor informar o Endereço."
                      isInvalid={!cardRecipientData?.address?.street}
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col>
                    <Input
                      maxLength="10"
                      type="text"
                      label="Número*:"
                      value={cardRecipientData?.address?.number || ''}
                      name="address.number"
                      onChange={handleEdit}
                      errorMessage="Favor informar o Número."
                      isInvalid={!cardRecipientData?.address?.number}
                    />
                  </Col>

                  <Col>
                    <Input
                      label="Complemento:"
                      maxLength="40"
                      type="text"
                      value={cardRecipientData?.address?.complement?.toUpperCase() || ''}
                      name="address.complement"
                      onChange={handleEdit}
                    />
                  </Col>

                  <Col md="auto" className="mb-3 mb-lg-0">
                    <Input
                      maxLength="150"
                      label="Bairro*:"
                      type="text"
                      value={cardRecipientData?.address?.neighborhood?.toUpperCase() || ''}
                      name="address.neighborhood"
                      onChange={handleEdit}
                      errorMessage="Favor informar o Bairro."
                      isInvalid={!cardRecipientData?.address?.neighborhood}
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md="auto" className="mb-3 mb-lg-0">
                    <Input
                      label="Cidade*:"
                      value={cardRecipientData?.address?.city?.toUpperCase() || ''}
                      name="address.city"
                      onChange={handleEdit}
                      isInvalid={!cardRecipientData?.address?.city}
                      maxLength="150"
                      errorMessage="Favor informar a Cidade."
                    />
                  </Col>

                  <Col>
                    <Input
                      label="Estado*:"
                      type="text"
                      value={cardRecipientData?.address?.state?.toUpperCase() || ''}
                      onChange={handleEdit}
                      name="address.state"
                      isInvalid={!cardRecipientData?.address?.state}
                      maxLength="50"
                      errorMessage="Favor informar o Estado."
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col xs={3} lg={2} className="mb-3 mb-lg-0">
                    <Input
                      max="99"
                      htmlSize={2}
                      type="text"
                      min="11"
                      mask="11"
                      value={cardRecipientData?.address?.phoneDDD || ''}
                      name="address.phoneDDD"
                      isInvalid={isInvalidPhoneDDD()}
                      onChange={handleEdit}
                      label="DDD:"
                      errorMessage="DDD inválido"
                    />
                  </Col>

                  <Col xs={9} lg={4}>
                    <Input
                      type="text"
                      value={phoneNumber || ''}
                      name="address.phoneNumber"
                      label="Telefone:"
                      mask="1111-1111"
                      errorMessage="Telefone inválido"
                      isInvalid={isInvalidPhoneNumber()}
                      onChange={handleEditPhone}
                      maxLength="9"
                      errorMessage="Telefone inválido"
                    />
                  </Col>

                  <Col xs={3} lg={2}>
                    <Input
                      max="99"
                      type="text"
                      min="11"
                      mask="11"
                      label="DDD:"
                      isInvalid={isInvalidCellPhoneDDD()}
                      value={cardRecipientData?.address?.cellPhoneDDD || ''}
                      name="address.cellPhoneDDD"
                      onChange={handleEdit}
                      errorMessage="DDD inválido"
                    />
                  </Col>

                  <Col xs={9} lg={4}>
                    <Input
                      type="text"
                      label="Celular:"
                      mask="11111-1111"
                      value={cellPhoneNumber || ''}
                      isInvalid={isInvalidCellPhoneNumber()}
                      name="address.cellPhoneNumber"
                      errorMessage="Celular inválido"
                      onChange={handleEditCellPhone}
                      maxLength="20"
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col xs={12} lg={8}>
                <Form.Group controlId="dataUpdate">
                  <Form.Check
                    type="checkbox"
                    required={true}
                    label="Estou ciente que os novos dados informados substituirão os dados atuais e serão utilizados pela Unimed Curitiba para qualquer finalidade relacionada ao plano de saúde."
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xs={12} lg={8}>
                <Form.Group controlId="mailAddress">
                  <Form.Check
                    type="checkbox"
                    required={true}
                    label="Estou ciente de que novo endereço será utilizado para envio de correspondências e boletos de cobrança das mensalidades."
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xs={12} lg={8}>
                <div className="button-container">
                  <CustomButton
                    color="primary"
                    text="Atualizar cadastro"
                    iconAlign="right"
                    disabled={errorRecipent ? true : false}
                    className="mt-2"
                    type="submit"
                  />
                </div>
              </Col>
            </Row>
          </Form>
        </Container>
      )}

      <CustomModal
        open={modalOpened}
        closeModal={() => setModalOpened(false)}
        size="sm"
        title="Atualização cadastral"
        footer={{
          closeButton: true,
        }}
      >
        <div className="update-profile__modal-container">
          <strong>{message}</strong>
        </div>
      </CustomModal>

      <CustomModal
        open={modalZipCodeOpened}
        closeModal={() => setModalZipCodeOpened(false)}
        size="lg"
        title={`Selecione o endereço para o CEP ${cardRecipientData.address.zipcode}`}
        footer={{
          closeButton: true,
        }}
      >
        <div
          className="update-profile__modal-container p-3"
          style={{ display: 'flex', height: '80%', marginBottom: '60px' }}
        >
          <div className="table-responsive" style={{ marginBottom: '80px' }}>
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Rua</th>
                  <th>Bairro</th>
                  <th>Cidade</th>
                  <th>Estado</th>
                </tr>
              </thead>
              <tbody>
                {zipCodeList?.length &&
                  zipCodeList.map((item, index) => (
                    <tr key={index} onClick={() => setSelectedZipCode(index)}>
                      <td>{item.street}</td>
                      <td>{item.neighborhood}</td>
                      <td>{item.locale}</td>
                      <td>{item.state}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </CustomModal>
    </div>
  )
}

export default AtualizacaoCadastral
